/**
 * Opt-in pill dropdown.
 *
 * Add class "fk-dropdown" to a single select. Shop sort selects are marked
 * automatically. The native select stays in the form and a bubbling change
 * event is what submits WooCommerce ordering.
 */
(function () {
  "use strict";

  function shouldSkip(select) {
    if (!select || select.multiple) {
      return true;
    }

    if (select.querySelector("optgroup")) {
      return true;
    }

    if (
      select.classList.contains("select2-hidden-accessible") ||
      select.classList.contains("wc-enhanced-select") ||
      select.classList.contains("country_select") ||
      select.classList.contains("state_select")
    ) {
      return true;
    }

    if (
      select.closest("form.variations_form, table.variations") &&
      !select.classList.contains("wcsatt-options-product-dropdown")
    ) {
      return true;
    }

    return false;
  }

  function closeDropdown(wrap) {
    var trigger = wrap.querySelector(".fk-dropdown__trigger");
    var list = wrap.querySelector(".fk-dropdown__list");

    wrap.classList.remove("is-open");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    if (list) {
      list.hidden = true;
    }
  }

  function closeAll(except) {
    document.querySelectorAll("[data-fk-dropdown].is-open").forEach(function (wrap) {
      if (except && wrap === except) {
        return;
      }

      closeDropdown(wrap);
    });
  }

  function optionsOf(list) {
    return Array.prototype.slice.call(list.querySelectorAll(".fk-dropdown__option"));
  }

  function focusOption(options, index) {
    if (!options.length) {
      return;
    }

    var next = index;

    if (next < 0) {
      next = 0;
    }

    if (next > options.length - 1) {
      next = options.length - 1;
    }

    options[next].focus();
  }

  function openDropdown(wrap) {
    var trigger = wrap.querySelector(".fk-dropdown__trigger");
    var list = wrap.querySelector(".fk-dropdown__list");

    closeAll(wrap);
    wrap.classList.add("is-open");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "true");
    }

    if (list) {
      list.hidden = false;
      var selected = list.querySelector('[aria-selected="true"]');
      (selected || list.querySelector(".fk-dropdown__option")).focus();
    }
  }

  function commit(wrap, value) {
    var select = wrap.querySelector("select");
    var list = wrap.querySelector(".fk-dropdown__list");
    var label = wrap.querySelector(".fk-dropdown__label");
    var trigger = wrap.querySelector(".fk-dropdown__trigger");
    var chosen = null;

    if (!select || !list) {
      return;
    }

    select.value = value;

    optionsOf(list).forEach(function (option) {
      var isChosen = option.getAttribute("data-value") === value;
      option.setAttribute("aria-selected", isChosen ? "true" : "false");

      if (isChosen) {
        chosen = option;
      }
    });

    if (label && chosen) {
      label.textContent = chosen.textContent;
    }

    closeDropdown(wrap);

    if (trigger) {
      trigger.focus();
    }

    select.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function onListKeydown(event) {
    var list = event.currentTarget;
    var wrap = list.closest("[data-fk-dropdown]");
    var options = optionsOf(list);
    var index = options.indexOf(document.activeElement);
    var trigger = wrap.querySelector(".fk-dropdown__trigger");

    if (event.key === "ArrowDown") {
      event.preventDefault();
      focusOption(options, index + 1);
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      focusOption(options, index - 1);
    } else if (event.key === "Home") {
      event.preventDefault();
      focusOption(options, 0);
    } else if (event.key === "End") {
      event.preventDefault();
      focusOption(options, options.length - 1);
    } else if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();

      if (document.activeElement && document.activeElement.getAttribute("data-value") !== null) {
        commit(wrap, document.activeElement.getAttribute("data-value"));
      }
    } else if (event.key === "Escape") {
      event.preventDefault();
      closeDropdown(wrap);

      if (trigger) {
        trigger.focus();
      }
    }
  }

  function measure(wrap) {
    var list = wrap.querySelector(".fk-dropdown__list");

    if (!list) {
      return;
    }

    var wasHidden = list.hidden;

    list.hidden = false;
    list.style.visibility = "hidden";
    list.style.position = "absolute";
    list.style.width = "max-content";

    var widest = 0;

    optionsOf(list).forEach(function (option) {
      option.style.width = "max-content";
      widest = Math.max(widest, option.getBoundingClientRect().width);
      option.style.width = "";
    });

    list.style.visibility = "";
    list.style.position = "";
    list.style.width = "";
    list.hidden = wasHidden;

    if (widest) {
      wrap.style.minWidth = Math.ceil(widest) + "px";
    }
  }

  function enhance(select) {
    if (select.dataset.fkDropdownBound === "1" || shouldSkip(select)) {
      return;
    }

    select.dataset.fkDropdownBound = "1";

    var wrap = document.createElement("div");
    wrap.className = "fk-dropdown is-enhanced";
    wrap.setAttribute("data-fk-dropdown", "");
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);

    select.tabIndex = -1;
    select.setAttribute("aria-hidden", "true");

    var listId = "fk-dropdown-" + Math.random().toString(36).slice(2, 10);
    var accessibleName = select.getAttribute("aria-label") || "";

    var trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "fk-dropdown__trigger";
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-expanded", "false");
    trigger.setAttribute("aria-controls", listId);

    if (accessibleName) {
      trigger.setAttribute("aria-label", accessibleName);
    }

    var label = document.createElement("span");
    label.className = "fk-dropdown__label";
    var selectedOption = select.options[select.selectedIndex];
    label.textContent = selectedOption ? selectedOption.text : "";

    var chevron = document.createElement("span");
    chevron.className = "fk-dropdown__chevron";
    chevron.setAttribute("aria-hidden", "true");

    trigger.appendChild(label);
    trigger.appendChild(chevron);

    var list = document.createElement("div");
    list.className = "fk-dropdown__list";
    list.id = listId;
    list.setAttribute("role", "listbox");
    list.hidden = true;

    if (accessibleName) {
      list.setAttribute("aria-label", accessibleName);
    }

    Array.prototype.forEach.call(select.options, function (option) {
      var item = document.createElement("div");
      item.className = "fk-dropdown__option";
      item.setAttribute("role", "option");
      item.setAttribute("data-value", option.value);
      item.setAttribute("aria-selected", option.selected ? "true" : "false");
      item.tabIndex = -1;
      item.textContent = option.text;
      list.appendChild(item);
    });

    wrap.appendChild(trigger);
    wrap.appendChild(list);

    trigger.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (wrap.classList.contains("is-open")) {
        closeDropdown(wrap);
      } else {
        openDropdown(wrap);
      }
    });

    trigger.addEventListener("keydown", function (event) {
      if (event.key !== "ArrowDown" && event.key !== "ArrowUp") {
        return;
      }

      event.preventDefault();

      if (!wrap.classList.contains("is-open")) {
        openDropdown(wrap);
      }
    });

    list.addEventListener("click", function (event) {
      var option = event.target.closest(".fk-dropdown__option");

      if (!option || !list.contains(option)) {
        return;
      }

      event.preventDefault();
      commit(wrap, option.getAttribute("data-value"));
    });

    list.addEventListener("keydown", onListKeydown);
    measure(wrap);
  }

  function initFkDropdowns() {
    document.querySelectorAll("form.woocommerce-ordering > select.orderby").forEach(function (select) {
      select.classList.add("fk-dropdown");
    });

    document.querySelectorAll("select.fk-dropdown").forEach(enhance);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFkDropdowns);
  } else {
    initFkDropdowns();
  }

  document.addEventListener("click", function (event) {
    if (!event.target.closest("[data-fk-dropdown]")) {
      closeAll();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeAll();
    }
  });

  window.initFkDropdowns = initFkDropdowns;
})();
